<template>
  <v-dialog v-model="dialogOpen" width="400" persistent>
    <v-card>
      <v-card-title>Send EDB Email</v-card-title>
      <v-card-text>
        <template>Are you sure?</template>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" small @click="submit" :disabled="isEDBEmailSending" :loading="isEDBEmailSending">CREATE</v-btn>
        <v-btn color="primary" small outlined @click="close" :disabled="isEDBEmailSending">CANCEL</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapState,mapActions } from 'vuex';
  export default {
    props: ['dialogOpen'],
    computed: {
      ...mapState('products',['currentProduct','isEDBEmailSending']),
    },
    methods: {
      ...mapActions('products',['sendEDBEmail']),
      async submit() {
        let isSuccess = await this.sendEDBEmail({p_id:this.currentProduct.id});
        if (isSuccess) {
          this.close();
        }
      },
      close() {
        this.$emit('close-dialog');
      },
    },
  }
</script>

<style lang="scss" scoped></style>
